import {getPublicProperty} from '../utils/getPublicProperty';
import {isBrandPortal} from '@netx/core-cms-next/utils/isBrandPortal';
import {AppPref} from '../constants';

export const canAccessHelpCenter = () => {
	return !isBrandPortal() && !!getPublicProperty(AppPref.HELP_URL);
};
